<template>
  <b-badge
    v-if="invoice"
    pill
    class="invoice-badge d-inline-flex m-1"
    :class="[{'not-paid-for-sales-report': invoice.is_not_paid_for_report, 'over-due': invoice.is_over_due }, invoiceStatusClass]"
  >
    <a
      href="#"
      @click.prevent="showEditInvoicesModal(invoice)"
      v-b-tooltip.html="{ variant: 'base' }"
      :title="'Edit invoice ' + (invoice.invoice_number ? invoice.invoice_number : '')">
      <font-awesome-icon icon="edit"/>
    </a>
    <a
      :id="'invoice-file-link-' + invoice.id"
      class="ml-1"
      :class="{ 'disabled': !invoice.invoice_number }"
      target="_blank"
      :href="invoice.download_url"
      :disabled="!invoice.invoice_number"
    >
      <font-awesome-icon icon="file-invoice"/>
    </a>
    <b-popover
      v-if="!!invoice.invoice_number"
      :target="'invoice-file-link-' + invoice.id"
      triggers="hover focus"
      class="invoice-pdf-link-popover"
    >
      <p class="invoice-popover-text m-1">{{ 'View invoice ' + (invoice.invoice_number ? invoice.invoice_number : '') }}</p>
      <b-badge
        class="invoice-badge d-inline-flex m-1"
        :class="[invoiceStatusClass]"
        v-for="(template, key) in templates"
        :key="key"
        pill
      >
        <b-link
          class="template-link invoice-popover-text"
          target="_blank"
          :href="invoice.download_url + '/' + template.name"
        >
          {{ template.name }}
        </b-link>
      </b-badge>
    </b-popover>
    <a
      class="ml-1"
      :class="{ 'disabled': !invoice.invoice_number }"
      :disabled="!invoice.invoice_number"
      target="_blank"
      @click="!!invoice.worklogs_report_url ? download(invoice.worklogs_report_url) : null"
      v-b-tooltip.html="{ variant: 'base' }"
      :title="'Download worklogs report ' + (invoice.invoice_number ? invoice.invoice_number : '')">
      <font-awesome-icon icon="file-download" />
    </a>
      <div class="btn-group btn-group__actions" role="group">
          <b-dropdown
                  class="dropdown__theme-light navbar__dropdown table__dropdown"
                  right
                  variant="link"
                  toggle-class="text-decoration-none"
                  no-caret
          >
              <template v-slot:button-content>
                  <span class="material-icons icon-image-preview">
                    more_vert
                  </span>
              </template>
              <b-dropdown-item-button @click.prevent="showSendInvoiceEmailModal(invoice)">
                <span class="dropdown-item-link" :class="{ 'active-action-item': !invoice.email_sent_date }">
                  <font-awesome-icon icon="envelope" /> Send invoice {{ invoice.email_sent_date ? '(sent)' : '' }}
                </span>
              </b-dropdown-item-button>
              <b-dropdown-item-button @click.prevent="markPaidAndReload(invoice)">
                  <span class="dropdown-item-link" :class="{ 'active-action-item': !invoice.is_paid }">
                    &nbsp;<font-awesome-icon icon="dollar-sign" />&nbsp;&nbsp;Mark Paid {{ !invoice.is_paid ? '' : '(marked)' }}
                  </span>
              </b-dropdown-item-button>
          </b-dropdown>
      </div>
      <FinanceInvoicesModal
        v-model="editInvoices.show"
        mode="edit"
        :data="editInvoices.form"
        :title="editInvoices.title"
        :submitButtonText="editInvoices.submitButtonText"
        :bankDetails="getOwnBankDetails"
        :clientBankDetails="getClientsBankDetailsAll"
        :templates="getTemplates"
        :projects="getActualProjects"
        :statuses="getStatuses"
        :types="getInvoicesTypes"
        :isLoading="getIsModalLoading"
        @submit="editFinanceInvoices"
      />
      <FinanceInvoicesEmailModal
        v-model="sendEmailModal.show"
        :title="'test title'"
        :submitButtonText="'test'"
        :invoiceId="sendEmailModal.invoice ? sendEmailModal.invoice.id : null"
        :isLoading="getIsModalLoading"
        @submit="invoiceEmailSent"
      />
  </b-badge>
</template>
<script>
  import {cloneDeep} from 'lodash'
  import InvoiceFormModal from '../mixins/InvoiceFormModal'
  import FinanceInvoicesModal from '@components/modals/FinanceInvoicesModal'
  import FinanceInvoicesEmailModal from '@components/modals/FinanceInvoicesEmailModal'

  export default {
  mixins: [ InvoiceFormModal ],
  components: {
    FinanceInvoicesModal, FinanceInvoicesEmailModal
  },
  props: {
    templates: {
      type: Array
    },
    item: {
      type: Object,
      default: () => {}
    }
  },
  data () {
    return {
      invoice: null,
      editInvoices: {
        show: false,
        title: 'Edit Invoice',
        submitButtonText: 'Save',
        form: null
      },
      sendEmailModal: {
        invoice: null,
        show: false
      }
    }
  },
  watch: {
    'item': {
      deep: true,
      immediate: true,
      handler (item) {
        this.invoice = item
      }
    }
  },
  computed: {
    invoiceStatusClass () {
      if (this.invoice.invoice_status.name === 'new') {
        return 'status-new'
      } else if (this.invoice.invoice_status.name === 'sent') {
        return 'status-sent'
      } else if (this.invoice.invoice_status.name === 'paid') {
        return 'status-paid'
      }
      return ''
    }
  },
  methods: {
    editFinanceInvoices (fields) {
      if (this.invoice.id) {
        this.updateInvoice(fields)
          .then(({ status, data }) => {
            this.hideEditInvoicesModal()
            this.invoice = cloneDeep(data)
            this.$emit('savedInvoice', { status, data: this.invoice })
            this.$emit('reloadInvoices')
          })
      } else {
        this.createInvoice(fields)
          .then(({ status, data }) => {
            this.hideEditInvoicesModal()
            this.invoice = cloneDeep(data)
            this.$emit('savedInvoice', { status, data: this.invoice })
            this.$emit('reloadInvoices')
          })
      }
    },
    markPaidAndReload (invoice) {
      this.$api.finances.markInvoicePaid(invoice.id)
        .then(({ data }) => {
          this.invoice = cloneDeep(data)
          this.$snotify.success(
            'Invoice successfully marked as paid',
            'Success',
            this.$store.state.snotify
          )
          this.$emit('reloadInvoices')
        }, error => {
          this.outputErrorNotification(error)
        })
    },
    showEditInvoicesModal (item) {
      this.editInvoices.show = true
      this.editInvoices.form = cloneDeep(item)
    },
    showSendInvoiceEmailModal (item) {
      this.sendEmailModal.invoice = item
      this.sendEmailModal.show = true
    },
    hideEditInvoicesModal () {
      this.editInvoices.show = false
      this.editInvoices.form = null
    },
    invoiceEmailSent (invoice) {
      this.invoice = cloneDeep(invoice)
      this.sendEmailModal.show = false
      this.$emit('reloadInvoices')
    },
    download (url) {
      window.location.assign(url)
    }
  }
}
</script>

<style lang="scss" scoped>
  .invoice-badge {
    font-size: 14px;
    padding: 5px 12px;
    background-color: #DEEBFF;
    a {
      cursor: pointer;
      margin-top: 1px;
    }
  }
  .invoice-popover-text {
    font-size: 13px;
  }
  .template-link {
    text-decoration: none
  }
  .status-new{
    background-color: #faf0be;
  }
  .status-new.over-due{
    background-size: 5px 5px!important;
    background-image: linear-gradient(135deg,lightgoldenrodyellow 25%,#ffa07a 0,#ffa07a 50%,lightgoldenrodyellow 0,lightgoldenrodyellow 75%,#ffa07a 0,#ffa07a) !important;
  }
  .status-sent{
    background-color: #ede742;
  }
  .status-sent.over-due{
    background-size: 5px 5px!important;
    background-image: linear-gradient(135deg,#ede742 25%,#ffa07a 0,#ffa07a 50%,#ede742 0,#ede742 75%,#ffa07a 0,#ffa07a) !important;
  }
  .status-paid{
    background-color: #deebff;
  }
  .not-paid-for-sales-report {
    border: 2px solid #f2b616;
  }
  .active-action-item {
    color: #1a237e;
  }
</style>
<style lang="scss">
  .invoice-badge .dropdown .dropdown-toggle {
      width: 16px;
      height: 16px;
      .material-icons {
        line-height: 15px;
        font-size: 18px;
      }
  }
</style>
